import React from 'react';
import { formatXg, getPossessionSplit, getShotsTotal, toNumber } from './LiveMatchStats';

/**
 * Compact stats summary. Used by the desktop side rail and by the half-time
 * snapshot, where a full stats table would drown the moment.
 *
 * Deliberately carries no `live-match-stats` test id: it must never be
 * mistaken for the full stats panel, and both can be on screen at once.
 */
function MatchGlanceCard({ title, teamOne, teamTwo }) {
    const possession = getPossessionSplit(teamOne, teamTwo);
    const homeShots = getShotsTotal(teamOne?.stats);
    const awayShots = getShotsTotal(teamTwo?.stats);
    const homeOnTarget = toNumber(teamOne?.stats?.final_shots_on);
    const awayOnTarget = toNumber(teamTwo?.stats?.final_shots_on);

    const rows = [
        possession ? { id: 'possession', label: 'Possession', home: `${possession.home}%`, away: `${possession.away}%` } : null,
        { id: 'xg', label: 'Expected goals', home: formatXg(teamOne?.stats?.xg_total), away: formatXg(teamTwo?.stats?.xg_total) },
        { id: 'shots', label: 'Shots', home: homeShots, away: awayShots },
        { id: 'on-target', label: 'On target', home: homeOnTarget, away: awayOnTarget }
    ].filter(Boolean);

    return (
        <div className="mx-card" data-testid="match-glance">
            <h5>{title}</h5>
            {rows.map((row) => (
                <div className="mx-glance-row" key={row.id}>
                    <span className="mx-glance-row__value">{row.home}</span>
                    <span className="mx-glance-row__label">{row.label}</span>
                    <span className="mx-glance-row__value mx-glance-row__value--away">{row.away}</span>
                </div>
            ))}
        </div>
    );
}

export default MatchGlanceCard;
